module.exports = __webpack_public_path__ + "img/event-ic-btn-01.50b9927a.png";